<template>
    <div class="rating-star">
        <div
            class="rating-stars-top"
            :style="{'width': ratingRange}">
            <i class="lt4-Star"></i>
            <i class="lt4-Star"></i>
            <i class="lt4-Star"></i>
            <i class="lt4-Star"></i>
            <i class="lt4-Star"></i>
        </div>
        <div class="rating-stars-bottom">
            <i class="lt4-Star"></i>
            <i class="lt4-Star"></i>
            <i class="lt4-Star"></i>
            <i class="lt4-Star"></i>
            <i class="lt4-Star"></i>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ratingRange: {
                default: '0%',
            },
        },
    };
</script>
